export var INCREMENT_YEAR = 'INCREMENT_YEAR';
export var DECREMENT_YEAR = 'DECREMENT_YEAR';
export var INCREMENT_MONTH = 'INCREMENT_MONTH';
export var DECREMENT_MONTH = 'DECREMENT_MONTH';
export var SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export var SET_FOCUSSED_DATE = 'SET_FOCUSSED_DATE';
export var ALLOW_CELL_FOCUS = 'ALLOW_CELL_FOCUS';
export var PREVENT_CELL_FOCUS = 'PREVENT_CELL_FOCUS';
export var SHOW_CALENDAR = 'SHOW_CALENDAR';
export var HIDE_CALENDAR = 'HIDE_CALENDAR';